// extracted by mini-css-extract-plugin
export default {"commoditiesTemplateWrapper":"CommoditiesPage_commoditiesTemplateWrapper__rDQLK"};